import React from 'react';
import type { Nullable } from 'corgi-types';
import type { ReclamationReasonValue } from 'graphql-ts-types';

import { HeadlineH8 } from 'common/components/Typography';

export interface ReasonSectionProps {
  reason: Nullable<ReclamationReasonValue>;
}

const ReasonSection = ({ reason }: ReasonSectionProps) =>
  reason && <HeadlineH8 data-testid="reason">{reason.title}</HeadlineH8>;

export default ReasonSection;
